import React, { useEffect, useState }                                                   from 'react';
import { Spinner }                                                                      from 'react-bootstrap';
import { useDispatch, useSelector }                                                     from 'react-redux';

import AuthoritiesService                                                               from '../../../services/AuthoritiesService';

import { MSG_DELETE, MSG_NOT_REVERT_OPERATION }                                         from '../../../constants/messages';
import { ACTION_DELETE, ACTION_EDIT, ACTION_ENABLE }                                    from '../../extras/actionTypes';
import { ConfirmDeleteMessage }                                                         from '../../extras/toastMessages';

import TableList                                                                        from '../../layout/TableList';
import QuickFilter                                                                      from '../../layout/QuickFilter';

import { listFunctionariesAction, editFunctionariesAction, deleteFunctionariesAction }  from '../../../actions/functionariesActions';
import { enableFunctionariesAction }                                                    from '../../../actions/functionariesActions';

import { FUNCIONARIOS_CREAR, FUNCIONARIOS_ELIMINAR, FUNCIONARIOS_MODIFICAR }            from '../../../data/objects';
import { PARAMETROS_ELIMINAR, PARAMETROS_MODIFICAR }                                    from '../../../data/objects';




const FunctionaryList = props => {
    
    
    // ==========================================================================================
    // DECLARACIONES ----------------------------------------------------------------------------
    // ==========================================================================================
    
    const params = { sort: 'apellido:asc,nombre:asc' }

    // Tomo los props
    const { handleOpen, handleClose } = props;
    
    // Inicializo el dispatch
    const dispatch = useDispatch();

    // Inicializo el state local
    const [ data, setData ] = useState(null);
    
    
    
    // ==========================================================================================
    // CARGA DE VALORES -------------------------------------------------------------------------
    // ==========================================================================================
    
    // Traigo el store de persona tipos
    const authorities = useSelector(state => state.auth.authorities);    
    const functionaries = useSelector( state => state.functionaries.functionaries );
    const functionariesLoading = useSelector( state => state.functionaries.loading );        
    
    
    
    // ==========================================================================================
    // FUNCIONES --------------------------------------------------------------------------------
    // ==========================================================================================
    
    // Manjo la eliminación
    const handleDelete = item => {
        // Confirmación
        ConfirmDeleteMessage(
            MSG_DELETE,
            MSG_NOT_REVERT_OPERATION,
            () => {
                dispatch( deleteFunctionariesAction(item) )
            }
        )
    } 
    
    // Manejo de la edición
    const handleEdit = item => {
        // Llamo al dispatch de edición
        dispatch( editFunctionariesAction(item, handleOpen) );
    }

    // Manejo de la habilitación
    const handleEnable = item => {
        dispatch( enableFunctionariesAction(item) );
    }

    // Inicializo las cabeceras
    const headers = [
        {   name: 'Apellido',
            width: null,
            style: null,
            field: 'apellido'
        },
        {   name: 'Nombre',
            width: null,
            style: null,
            field: 'nombre'
        },
        {   name: 'Tipo',
            width: null,
            style: 'text-center',
            field: 'tipo',
            subfield: 'descripcion'
        },
        {   name: 'Unidad Judicial',
            width: null,
            style: 'text-center',
            field: 'unidad',
            subfield: 'descripcion'
        },
        {   name: 'Email',
            width: null,
            style: null,
            field: 'email'
        },
        {   name: 'Teléfono',
            width: null,
            style: null,
            field: 'telefono'
        },
        {   name: 'Acción',
            width: '10%',
            style: 'text-center',
            actions: [
                {   name: ACTION_ENABLE,
                    handle: handleEnable,
                    granted: authorities && AuthoritiesService.hasPermission(authorities, FUNCIONARIOS_CREAR)
                },
                {   name: ACTION_EDIT,
                    handle: handleEdit,
                    granted: authorities && AuthoritiesService.hasPermission(authorities, FUNCIONARIOS_MODIFICAR)
                },
                {   name: ACTION_DELETE,
                    handle: handleDelete,
                    granted: authorities && AuthoritiesService.hasPermission(authorities, FUNCIONARIOS_ELIMINAR)
                }
            ]
        }
    ];
    
    // Cargo los datos
    useEffect(() => {
        // Verifico si hay datos
        if(functionaries)
        {   // Seteo los datos
            setData(functionaries);
        }
        else
        {   // Si no hay datos, debo cargarlo
            dispatch( listFunctionariesAction(params) );
        }
    }, [functionaries]);



    // ==========================================================================================
    // RENDERIZO --------------------------------------------------------------------------------
    // ==========================================================================================
    
    return (
        <div className="row">
            <div className="col-12">
                <div className="card shadow mb-4">
                    <div className="card-header py-3">
                        <h6 className="m-0 font-weight-bold text-primary">Listado</h6>
                    </div>
                    <div className="card-body">
                        <QuickFilter
                            initialData={functionaries}
                            headers={headers}
                            setData={setData}
                        />
                        {   functionariesLoading 
                                ? 
                                    <Spinner animation="border" role="status">
                                        <span className="sr-only">Cargando...</span>
                                    </Spinner>
                                : 
                                    null
                        }
                        {   data 
                                ? 
                                    <TableList
                                        prefix="functionary"
                                        headers={headers}
                                        items={data}
                                        state={{
                                            field: 'activo',
                                            disabledClass: 'table-danger',
                                            disabledValue: 0,
                                            hideActions: true
                                        }}
                                    />
                                : 
                                    null
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FunctionaryList;